var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardAverageResponseTimeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 79.5,
    height: 79.5,
    viewBox: "0 0 79.5 79.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_289",
    x: 0,
    y: 0,
    width: 79.5,
    height: 79.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#414141",
    floodOpacity: 0.208
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161870",
    "data-name": "Group 161870",
    transform: "translate(-198.75 -576.75)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 198.75, 576.75)",
    filter: "url(#Ellipse_289)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_289-2",
    "data-name": "Ellipse 289",
    cx: 30.75,
    cy: 30.75,
    r: 30.75,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(210.75 585.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83825",
    "data-name": "Path 83825",
    d: "M27.75,39.5A11.75,11.75,0,1,1,39.5,27.75,11.75,11.75,0,0,1,27.75,39.5Zm9.4-11.75a9.4,9.4,0,1,0-9.4,9.4A9.4,9.4,0,0,0,37.15,27.75Zm-4.7-1.175a1.175,1.175,0,1,1,0,2.35H28.925a2.357,2.357,0,0,1-2.35-2.35v-4.7a1.175,1.175,0,1,1,2.35,0v4.7Z",
    fill: "#8a8a8a",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardAverageResponseTimeIcon);
export default __webpack_public_path__ + "static/media/dashboard-average-response-time-icon.2e03c743e364997f555a6472c3f05833.svg";
export { ForwardRef as ReactComponent };